// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        requiresTicket: yup.boolean().nullable(),
        requiresFollowUp: yup.boolean().nullable(),
        requiresExpectedValueOnCompletion: yup.boolean().nullable(),
        allowsWorkOrderCreation: yup.boolean().nullable(),
        requiresContactsOnCreation: yup.boolean().nullable(),
        metadata: yup
            .object()
            .shape({
                transitions: yup
                    .array()
                    .of(
                        yup
                            .object()
                            .shape({
                                transition: yup.string().nullable(),
                                canBeExecutedManually: yup.boolean().nullable(),
                                executeParentTransitions: yup.array().of(yup.string()).nullable(),
                                parentStatesRequired: yup.array().of(yup.string()).nullable(),
                                parentStatesForbidden: yup.array().of(yup.string()).nullable()
                            })
                            .nullable()
                    )
                    .nullable()
            })
            .nullable() // metadataValidationSchema(intl, ['transition', 'canBeExecutedManually', 'executeParentTransitions', 'parentStatesRequired', 'parentStatesForbidden' ])
    });

export default validationSchema;
